module.exports = __webpack_public_path__ + "static/media/pencil.ffd1afc4.svg";